import useSWR from "swr";
import { fetcher, FetchError } from "lib/actions/fetcher";
import { endpointsAutodeskImport } from "../actions/endpointsAutodeskImport";
import { AutodeskHubModel } from "../types/AutodeskHubModel";
import { AutodeskFolderModel } from "../types/AutodeskFolderModel";

export function useAutodeskTopFolders(
  connectedAccountId: number | null,
  hub: AutodeskHubModel | null,
  projectId: string | null,
) {
  const { data, error, isLoading, mutate } = useSWR<
    AutodeskFolderModel[],
    FetchError
  >(
    connectedAccountId !== null &&
      hub?.region &&
      projectId &&
      endpointsAutodeskImport.topFolders(
        connectedAccountId,
        hub.id,
        projectId,
        hub.region,
      ),
    fetcher,
    // A background retry would swap the error panel for a spinner, dropping a
    // Reconnect that is still waiting on its popup.
    { shouldRetryOnError: false },
  );

  return { topFolders: data, hasError: !!error, error, isLoading, mutate };
}
